// extracted by mini-css-extract-plugin
export var accordionButton = "accordion-module--accordionButton--1WfJz";
export var accordion = "accordion-module--accordion--b55bT";
export var accordionItem = "accordion-module--accordionItem--2_Qte";
export var accordionHeading = "accordion-module--accordionHeading--9lMwg";
export var accordionPanel = "accordion-module--accordionPanel--1FO1M";
export var panelText = "accordion-module--panelText--P9RW0";
export var panelText_description = "accordion-module--panelText_description--2umGF";
export var panelText_link = "accordion-module--panelText_link--1B61F";
export var mediaWrap = "accordion-module--mediaWrap--YZybq";